import React, { ReactNode, useCallback, useMemo, useState } from 'react';
import { IDeviceSelector } from '~/services/api/devices/types';
import { IIdName } from '~/services/api/types';
import PatientEnrollmentOptionsContext from './PatientEnrollmentContext';
import { IStorageFile, IStorageFilesSelectors } from '~/services/api/storageFiles/types';
import { IInsurancesSelectors } from '~/services/api/insurances/types';

const PatientEnrollmentOptionsProvider = ({ children }: { children: ReactNode }) => {
  const [programs, setPrograms] = useState<IIdName[]>([]);
  const [managers, setManagers] = useState<IIdName[]>([]);
  const [devices, setDevices] = useState<IDeviceSelector[]>([]);
  const [insuranceSelectors, setInsuranceSelectors] = useState<IInsurancesSelectors>({ names: [] });
  const [storageFilesSelectors, setStorageFilesSelectors] = useState<IStorageFilesSelectors>({
    storageFileTypes: [],
    documentTypes: [],
  });
  const [storageFiles, setStorageFiles] = useState<IStorageFile[]>([]);

  const onStorageFileUploaded = (storageFile: IStorageFile) => {
    setStorageFiles(oldStorageFiles => [...oldStorageFiles, storageFile]);
  };

  const onStorageFileRemove = useCallback(
    (storageFile: IStorageFile) =>
      setStorageFiles(oldStorageFiles => oldStorageFiles.filter(x => x !== storageFile)),
    [setStorageFiles],
  );

  const value = useMemo(
    () => ({
      programs,
      managers,
      devices,
      insuranceSelectors,
      storageFilesSelectors,
      storageFiles,
      setPrograms,
      setManagers,
      setDevices,
      setInsuranceSelectors,
      setStorageFilesSelectors,
      onStorageFileUploaded,
      onStorageFileRemove,
    }),
    [programs, managers, devices, insuranceSelectors, storageFilesSelectors, storageFiles],
  );

  return (
    <PatientEnrollmentOptionsContext.Provider value={value}>
      {children}
    </PatientEnrollmentOptionsContext.Provider>
  );
};

export default PatientEnrollmentOptionsProvider;
